module.exports = __webpack_public_path__ + "static/ogimg-planetid-388f9775dc356286ea625957f7d07b1c.jpg";